import React from "react";

const Bash_Unzip = () => {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Bash Unzip</h2>
      <p>Extract files from a .zip archive.</p>
      <h4 className="font-medium mt-4">Syntax</h4>
      <pre><code>unzip archive.zip</code></pre>
      <h4 className="font-medium mt-4">Examples</h4>
      <pre><code>unzip archive.zip -d outdir</code></pre>
      <h4 className="font-medium mt-4">Notes</h4>
      <p>Use -l to list contents without extracting.</p>
    </div>
  );
};

export default Bash_Unzip;
